<div class="min-h-screen bg-[#f5f5f7] font-sans flex items-center justify-center p-6 selection:bg-emerald-100 selection:text-emerald-900">

  <div class="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-emerald-50/50 blur-[120px] rounded-full -z-10"></div>

  <div class="w-full max-w-[480px] animate-in fade-in slide-in-from-bottom-8 duration-1000 ease-out">

    <div class="flex flex-col items-center mb-12">
      <img src="ventora.webp" class="h-10">

    </div>

    <div class="bg-white rounded-[40px] shadow-[0_40px_100px_rgba(0,0,0,0.03)] border border-zinc-100/80 p-10 md:p-12">
      <form class="space-y-6">

        <div class="space-y-2">
          <label class="text-[11px] font-black text-zinc-400 uppercase tracking-[0.2em] ml-1">Email Address</label>
          <input type="email"
                 [(ngModel)]="username"
                 [ngModelOptions]="{standalone: true}"
                 placeholder="name@aura.com"
                 class="w-full px-6 py-4 rounded-2xl bg-zinc-50 border border-zinc-100 text-zinc-900 placeholder:text-zinc-300 focus:outline-none focus:ring-4 focus:ring-emerald-500/10 focus:border-emerald-500 transition-all duration-300">
        </div>

        <div class="space-y-2">
          <div class="flex justify-between items-center px-1">
            <label class="text-[11px] font-black text-zinc-400 uppercase tracking-[0.2em]">Password</label>
          </div>
          <input type="password"
                 placeholder="••••••••"
                 [ngModelOptions]="{standalone: true}"
                 [(ngModel)]="password"
                 class="w-full px-6 py-4 rounded-2xl bg-zinc-50 border border-zinc-100 text-zinc-900 placeholder:text-zinc-300 focus:outline-none focus:ring-4 focus:ring-emerald-500/10 focus:border-emerald-500 transition-all duration-300">
        </div>

        <button
                (click)="login()";
                class="w-full py-4 mt-4 bg-zinc-900 text-white rounded-2xl font-bold text-[15px] tracking-wide
                       transition-all duration-500 hover:bg-emerald-600 hover:shadow-[0_20px_40px_rgba(16,185,129,0.2)]
                       active:scale-[0.98] flex items-center justify-center gap-3 group">
          <span>Sign In</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M14 5l7 7-7 7" />
          </svg>
        </button>
    <span class="text-center justify-center flex text-red-800">{{errorMessage}}
</span>
      </form>
    </div>


  </div>
</div>
